<template>
  <div id="pmlst-outcome">
    <div class="pmlst-outcome-wrapper">
      <div class="outcome">
        <fleet-outcome :outcome="outcome" />
      </div>
    </div>
  </div>
</template>

<script>
import FleetOutcome from '@/components/FleetOutcome.vue'

export default {
  name: 'pure-outcome-screen',
  components: { FleetOutcome },
  props: {
    outcome: {
      type: Object,
      required: true
    }
  }
}
</script>
